import React from 'react';
import UserOrganizationList from './UserOrganizationList';

function UserOrganizations() {
  return <UserOrganizationList />;
}
export default UserOrganizations;
